import ind from "./assets/img/ind.jpg";
import tra from "./assets/img/tra.jpg";
import cli from "./assets/img/cli.jpg";
import nin from "./assets/img/nin.jpg";
import gam from "./assets/img/gam.jpg";
import ent from "./assets/img/ent.jpg";
import p1 from "./assets/img/p1.jpg";
import p2 from "./assets/img/p2.jpg";
import p3 from "./assets/img/p3.jpg";

export const NAV = [
  ["Home", "#top"],
  ["About us", "#why"],
  ["Products", "#products"],
  ["Projects", "#projects"],
  ["Roadmap", "#process"],
  ["FAQ", "#faq"],
  ["Contacts", "#quote"],
];
export const SUB = [
  "Trampoline Park",
  "Indoor Playground",
  "Interactive Games",
  "Climbing Wall",
  "Ninja Park",
  "Entrance Software",
];
export const TICKS = [
  "Customized Designs",
  "Direct Factory Manufacturing",
  "International Shipping",
  "Professional Installation",
  "After-Sales Support",
];
export const WHY = [
  [
    "yel",
    "Direct From Our Factory",
    "Work directly with the manufacturer for customized solutions, better project coordination, and greater control over production.",
  ],
  [
    "navy",
    "Designed Around Your Space",
    "Our team develops customized playground and entertainment concepts tailored to your available space, target audience, and business objectives.",
  ],
  [
    "cyan",
    "Complete Turnkey Solutions",
    "From initial design and manufacturing to shipping and installation, we coordinate the essential stages of your project through one experienced partner.",
  ],
  [
    "mag",
    "Entertainment Solutions Under One Roof",
    "Explore a wide range of products, including indoor playgrounds, trampoline parks, soft play areas, climbing walls, ninja courses, and interactive games.",
  ],
  [
    "yel",
    "Support Beyond Installation",
    "Our relationship doesn't end when your project opens. We provide after-sales support and maintenance services to help you keep your entertainment facility running.",
  ],
];
export const PRODUCTS = [
  [
    "navy",
    "Indoor Playgrounds",
    "Create engaging indoor play spaces with customized play structures, slides, tunnels, climbing elements, and interactive play areas.",
    [ind],
  ],
  [
    "mag",
    "Trampoline Parks",
    "Build exciting trampoline parks featuring interconnected trampolines, jumping areas, foam pits, and dynamic activity zones.",
    [tra],
  ],
  [
    "yel",
    "Soft Play Areas",
    "Design colorful and engaging play environments for toddlers and younger children, combining safety, creativity, and fun.",
    [cli],
    "right",
  ],
  [
    "cyan",
    "Ninja Courses & Climbing Walls",
    "Add exciting physical challenges with customized obstacle courses, climbing walls, and adventure-based activities.",
    [nin, cli],
  ],
  [
    "navy",
    "Interactive Games",
    "Enhance your entertainment venue with interactive attractions designed to encourage engagement and repeat visits.",
    [gam],
  ],
  [
    "mag",
    "Custom Entertainment Projects",
    "Have a unique concept in mind? Our team can help develop a customized entertainment solution based on your requirements.",
    [ent],
  ],
];
export const STEPS = [
  [
    "yel",
    "Design & Planning",
    "We discuss your vision, available space, target audience, and project requirements to develop a customized concept.",
  ],
  [
    "navy",
    "Manufacturing",
    "Your equipment is manufactured at our factory according to the approved project specifications.",
  ],
  [
    "cyan",
    "Shipping & Logistics",
    "We coordinate shipping arrangements to help deliver your project to its destination.",
  ],
  [
    "mag",
    "Professional Installation",
    "Our team coordinates installation according to the agreed project scope and schedule.",
  ],
  [
    "yel",
    "After-Sales Support",
    "We provide support and maintenance services to help you maintain your equipment after installation.",
  ],
];
export const SERVICES = [
  ["yel", "Customized project design."],
  ["cyan", "In-house equipment manufacturing."],
  ["mag", "International shipping coordination."],
  ["yel", "Professional installation according to the agreed project scope."],
  ["cyan", "After-sales support and maintenance."],
];
export const PROJECTS = [
  [p1, "Baby Day"],
  [p2, "Peekaboo"],
  [p3, "Irbid Landmark"],
];
export const PROJECT_TYPES = [
  "Indoor Playground",
  "Trampoline Park",
  "Soft Play Area",
  "Ninja Course",
  "Interactive Games",
  "Complete Family Entertainment Center",
  "Other",
];
export const STAGES = [
  "Planning a New Project",
  "Comparing Suppliers",
  "Ready to Purchase",
];
export const FAQ = [
  [
    "Do you manufacture your own entertainment equipment?",
    "Yes. GEM manufactures entertainment equipment at its factory and provides customized solutions based on project requirements.",
  ],
  [
    "Can you design a complete indoor playground or trampoline park?",
    "Yes. We provide customized design solutions for indoor playgrounds, trampoline parks, and other entertainment facilities.",
  ],
  [
    "Do you provide shipping and installation?",
    "We coordinate shipping and offer installation services according to the project location and agreed scope.",
  ],
  [
    "Can you customize the equipment to fit my available space?",
    "Yes. Our team works with you to develop a solution based on your available space, project concept, and requirements.",
  ],
  [
    "Do you work with international clients?",
    "Yes. We work with clients on international entertainment projects. Shipping and installation arrangements are determined according to the destination and project scope.",
  ],
  [
    "How can I get a quotation?",
    "Complete our inquiry form with your contact information, project location, and requirements. Our team will contact you to discuss your project and quotation.",
  ],
  [
    "Do you provide after-sales support?",
    "Yes. We offer after-sales support and maintenance services according to the project requirements and agreed service arrangements.",
  ],
];

// [color, figure, label, isText]. Replace with real numbers (years, projects, countries) when you have them.
export const STATS = [
  ["yel", "5+", "Product lines"],
  ["blue", "200+", "Projects Completed Across the GCCe"],
  ["cyan", "10+", "Brand Partners", true],
  ["mag", "12+", "Markets served", true],
];
